import { FC } from "react";
import cn from "classnames";
import { useNavigate } from "react-router";
import { formatPriceDisplay } from "capitalrx-utilities";
import { PharmacyResultsCardProps } from "./PharmacyResultsCard.props";
import { Panel, Icon } from "capitalrx-components-2.0/lib/general";
import { useSetQuery } from "capitalrx-components-2.0/lib/hooks";

import styles from "./PharmacyResultsCard.module.scss";

export const PharmacyResultsCard: FC<PharmacyResultsCardProps> = ({
  price,
  priceUnavailableText = "Price Unavailable",
  className,
  priceButtonClassname,
  children,
  linkTo,
  isMaxUsualAndCustomaryCharge,
  providerId,
  distance,
}: PharmacyResultsCardProps) => {
  // Don't display price if Max U&C is charged
  if (isMaxUsualAndCustomaryCharge) {
    price = NaN;
  }

  const resultCardContainerClasses = cn(styles["ResultCardContainer"], className);
  const priceResultsClasses = cn({ [styles["Price"]]: price }, priceButtonClassname, {
    [styles["PriceUnavailable"]]: isNaN(Number(price)),
  });

  const navigate = useNavigate();
  const [, setQuery] = useSetQuery();

  let showPrice = "";
  if (price) {
    showPrice = formatPriceDisplay(Number(price));
  }

  const pharmacyDetailsHandler = () => {
    navigate({
      pathname: linkTo,
      search: setQuery({ providerId: `${providerId}`, price: `${price}`, distance: `${distance}` }),
    });
  };

  return (
    <button onClick={pharmacyDetailsHandler} className={styles.ResultCardWrapper}>
      <Panel className={resultCardContainerClasses}>
        {children}
        <div className={styles.PriceContainer}>
          <span className={priceResultsClasses}>{price ? showPrice : priceUnavailableText}</span>
          <Icon name="chevron-right" color="turquoise" className={styles.Carat} />
        </div>
      </Panel>
    </button>
  );
};
